var common = require('./common.js')
var { randomString } = require('./common.js')

const DELI = '-[/]-'

class Pubsub {
	constructor () {
		this.listeners = []
	}

	publish (topic, ...args) {
		common.map(this.listeners[topic], cb => cb(...args))
	}

	only (topic, cb) {
		var subid = topic + DELI + randomString(20)
		if (!this.listeners[topic]) this.listeners[topic] = {}
		this.listeners[topic] = { subid: cb }
		return subid
	}

	on (topic, cb) {
		var subid = topic + DELI + randomString(20)
		if (!this.listeners[topic]) this.listeners[topic] = {}
		this.listeners[topic][subid] = cb
		return subid
	}

	un (subid) {
		if (!subid) return
		var topic = subid.split(DELI)[0]
		if (!this.listeners[topic]) return
		delete this.listeners[topic][subid]
	}
}

module.exports = Pubsub
